"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shaSuffixLength = exports.defaultReplacement = exports.defaultRemove = exports.slugify = void 0;

var slugify_1 = __importDefault(require("slugify"));

var sha1_1 = __importDefault(require("sha1"));
/**
 *  SHA part is to not end up in situation of empty slug
 *  and avoid extending the slugify with all the possible unicode symbols
 */


exports.slugify = function (string, options) {
  return slugify_1.default(string, Object.assign({
    remove: exports.defaultRemove,
    replacement: exports.defaultReplacement
  }, options)) || sha1_1.default(string).slice(0, exports.shaSuffixLength);
}; // default allow list from slugify sans "


exports.defaultRemove = /[^\w\s$*_+~.()'!\-:@]+/g;
exports.defaultReplacement = "-";
exports.shaSuffixLength = 5;